import { Button, Flex, Text } from '@mantine/core';

import { useResearchPerfEvalOpen } from '@/module/ResearchPerfEval/model/ResearchPerfEvalQuery';

import { Content } from '@/core/components';

import { useAppNotification } from '@feature/utils';

interface OpenResearchPerfEvalBoxProps {
  year: number;
}

export function OpenResearchPerfEvalBox({ year }: OpenResearchPerfEvalBoxProps) {
  const notification = useAppNotification();
  const { mutate, isPending } = useResearchPerfEvalOpen(year);

  const onClick = () => {
    mutate(undefined, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <Content type="full">
      <Flex
        justify="space-between"
        align="center"
      >
        <Text fw="500">
          Deschide raport {year - 4} - {year}
        </Text>
        <Button
          size="sm"
          onClick={onClick}
          loading={isPending}
        >
          Deschide
        </Button>
      </Flex>
    </Content>
  );
}
